export const HELP_PAGE_URL = "/client/help";
export const LANDING_PAGE_URL = "/client/dashboard";
export const LOGIN_PAGE_URL = "/client/login";
export const TERMS_OF_USE_URL = "/client/terms_of_use";
export const EMAIL_REPORT_URL_PREFIX = "/client/emailReport";
export const PROFILE_URL = "/client/profile";
export const BILLING_URL = "/client/bill";
export const BILLING_MULTIPLE_URL = "/client/bills";
export const BABYPEEK_URL = "/client/babypeek";
export const BABYPEEK_URL_FAQ = "/client/babypeek-faq";
export const BABYPEEK_URL_FEEDBACK = "/client/babypeek-feedback";
export const LEGACY_PUBLIC_BABYPEEK_URL = "/client/public/babypeek";
export const LEGACY_FREE_TRAIT_BABYPEEK_URL = "/c/bp/trait";
export const REGISTER_URL = "/c/s"; // short link for text messages
export const PRETEST_REGISTER_URL = "/client/signup";
export const VERIFY_EMAIL_CONFIRMED_URL = "/client/verifyEmailConfirm";
export const RESET_PASSWORD_URL = "/client/login/resetPassword";
export const RESET_PASSWORD_SENT_URL = "/client/login/resetPassword/sent";
export const SCHEDULING_URL = "/client/scheduling";
export const GC_LEARN_MORE_URL = "/client/gc-learn-more";
export const CONTACT_US_URL = "/client/contactUs";
export const VERIFY_EMAIL_URL = "/client/verifyEmail";
export const VERIFY_EMAIL_SEND_AGAIN_URL = "/client/verifyEmailSendAgain";
export const ANEUPLOIDY_PAGE_URL = "/client/aneuploidyResults";
export const CARRIER_PAGE_URL = "/client/carrierResults";
export const CFC_PAGE_URL = "/client/cfcResults";
export const EXTERNAL_FORWARD_FETAL_SEX = "/client/forward/fetalSex";
export const TEST_INFO_URL = "/testSetup";
export const VIDEO_PAGE_URL = "/client/videos";

// Account public IDs are eight alphanumeric characters. Route params that accept
// one must say so, or `exact` single-segment routes swallow reserved words like
// `finder` and treat them as a clinic scope.
export const PORTAL_ACCOUNT_PUBLIC_ID_ROUTE_PATTERN = "([A-Za-z0-9]{8})";

// Canonical public blood-draw routes (patient-facing)
export const PHLEBOTOMY_INTAKE_URL = "/blooddraw";
export const PHLEBOTOMY_SEARCH_URL = "/blooddraw/search";
export const PHLEBOTOMY_CAMPAIGN_SOURCE_PARAM = "source";
export const PHLEBOTOMY_CUSTOMER_IO_SMS_SOURCE = "customer_io_sms";
export const PHLEBOTOMY_LOCATION_FINDER_URL = "/blooddraw/finder";
export const PHLEBOTOMY_PHONE_OPTIONS_URL = "/blooddraw/phone-options";
export const PHLEBOTOMY_MOBILE_OPTIONS_URL = "/blooddraw/mobile-options";
export const PHLEBOTOMY_MOBILE_REQUEST_URL = "/blooddraw/mobile-request";
export const PHLEBOTOMY_MOBILE_SCHEDULE_URL = "/blooddraw/mobile-schedule";

// Pre-blooddraw public paths kept ONLY for redirects (SMS/QR already in the wild)
export const PHLEBOTOMY_V1_INTAKE_URL = "/phlebotomy";
export const PHLEBOTOMY_V1_SEARCH_URL = "/phlebotomy-search";
export const PHLEBOTOMY_V1_LOCATION_FINDER_URL = "/phlebotomy-finder";
export const PHLEBOTOMY_V1_PHONE_OPTIONS_URL = "/phlebotomy-phone-options";
export const PHLEBOTOMY_V1_MOBILE_OPTIONS_URL = "/phlebotomy-mobile-options";
export const PHLEBOTOMY_V1_MOBILE_REQUEST_URL = "/phlebotomy-mobile-request";

// Legacy paths kept ONLY for already-delivered links / redirects (keep /client — important)
export const PHLEBOTOMY_LEGACY_HUB_URL = "/client/phlebotomy";
export const PHLEBOTOMY_LEGACY_SEARCH_URL = "/client/phlebotomy-search";
export const PHLEBOTOMY_LEGACY_REMINDER_URL = "/client/phlebotomy-reminder";
export const PHLEBOTOMY_LEGACY_LOCATION_FINDER_URL =
  "/client/phlebotomy-finder";
export const PHLEBOTOMY_LEGACY_PHONE_OPTIONS_URL =
  "/client/phlebotomy-phone-options";
export const PHLEBOTOMY_LEGACY_MOBILE_OPTIONS_URL =
  "/client/phlebotomy-mobile-options";
export const PHLEBOTOMY_LEGACY_MOBILE_REQUEST_URL =
  "/client/phlebotomy-mobile-request";

// Back-compat alias: hub/legacy redirect still uses this name in some call sites
export const PHLEBOTOMY_URL = PHLEBOTOMY_LEGACY_HUB_URL;
// Alias so older reminder references compile during transition
export const PHLEBOTOMY_REMINDER_URL = PHLEBOTOMY_INTAKE_URL;

export const NIPT_CONSENT = "/client/consent";
